module.exports = __webpack_public_path__ + "static/media/w (42).057deb49.jpg";